import { Mods, classNames } from '@lib/classNames/classNames';
import Link from 'next/link';
import React from 'react';

import { ButtonProps } from './types';

export const Button = (props: ButtonProps) => {
  const {
    className,
    disabled,
    children,
    variant,
    roleButton,
    ariaLabel,
    href,
    target,
    ...otherProps
  } = props;

  const mods: Mods = {
    [`cursor-pointer rounded-xl ${disabled ? 'bg-custom-surface-contrast-low text-text-base-tertiary' : 'bg-custom-base-inverse-primary text-custom-base-primary hover:bg-custom-base-inverse-secondary'} py-3 px-3 font-medium`]:
      variant === 'primary',
    [`cursor-pointer rounded-xl ${disabled ? 'bg-custom-surface-contrast-low text-text-base-tertiary' : 'bg-custom-surface-contrast-low text-text-base-primary hover:bg-custom-surface-contrast-mid'} py-3 px-3 font-medium`]:
      variant === 'secondary',
    ['cursor-pointer rounded-xl font-medium py-3 px-3 hover:text-text-base-secondary']:
      variant === 'tertiary',
    [`cursor-pointer rounded-xl font-medium py-3 px-3 ${disabled ? 'bg-custom-surface-contrast-low text-text-base-tertiary' : 'bg-surface-base-inverse-primary2 text-text-base-inverse-primary hover:bg-surface-base-inverse-secondary'}`]:
      variant === 'fourth',
  };

  if (href) {
    return (
      <Link
        href={href}
        target={target}
        rel="noopener noreferrer"
        className={classNames({
          cls: 'flex transition-colors duration-300',
          mods,
          additional: [className],
        })}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={classNames({
        cls: 'flex transition-colors duration-300',
        mods,
        additional: [className],
      })}
      type="button"
      role={roleButton || 'button'}
      disabled={disabled}
      aria-label={ariaLabel || 'button'}
      {...otherProps}
    >
      {children}
    </button>
  );
};
